import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullscreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '',
  fullscreen = false
}) => {
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24'
  };

  if (fullscreen) {
    return (
      <div className="fixed inset-0 w-screen h-screen flex items-center justify-center overflow-hidden">
        <video
          src="/video/loader.mp4"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="/video/loader.mp4" type="video/mp4; codecs=avc1.42E01E,mp4a.40.2" />
          <source src="/video/loader.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <video
        src="/video/loader.mp4"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className={sizeClasses[size]}
      >
        <source src="/video/loader.mp4" type="video/mp4; codecs=avc1.42E01E,mp4a.40.2" />
        <source src="/video/loader.mp4" type="video/mp4" />
      </video>
    </div>
  );
};